import { RefObject, useEffect } from 'react'

export const LONG_HOVER_DELAY = 1000

export const useLongHover = (
  ref: RefObject<HTMLElement>,
  onHoverStart: (e: MouseEvent) => void,
  onHoverEnd: (e: MouseEvent) => void,
  enterDelay?: number,
  exitDelay?: number,
  forceExitOnclick?: boolean,
) => {
  useEffect(() => {
    const element = ref.current
    if (!element) return

    let hovering = false
    let timeout: ReturnType<typeof setTimeout> | undefined

    const handleMouseEnter = (e: MouseEvent) => {
      hovering = true

      timeout = setTimeout(() => {
        if (hovering) onHoverStart(e)
      }, enterDelay ?? LONG_HOVER_DELAY)
    }

    const handleMouseLeave = (e: MouseEvent) => {
      // This is to check that whether the mouseleave is triggered by a click
      // and prevent triggering mouseleave if mouse is still inside the component.
      if (!forceExitOnclick && element.contains(document.elementFromPoint(e.clientX, e.clientY))) {
        return
      }

      hovering = false

      timeout = setTimeout(() => {
        if (!hovering) onHoverEnd(e)
      }, exitDelay ?? LONG_HOVER_DELAY)
    }
    element.addEventListener('mouseenter', handleMouseEnter)
    element.addEventListener('mouseleave', handleMouseLeave)
    element.addEventListener('click', handleMouseLeave)

    return () => {
      element.removeEventListener('mouseenter', handleMouseEnter)
      element.removeEventListener('mouseleave', handleMouseLeave)
      element.removeEventListener('click', handleMouseLeave)
      timeout && clearTimeout(timeout)
    }
  }, [onHoverEnd, onHoverStart, ref, enterDelay, exitDelay, forceExitOnclick])
}
